<template>
<div>
  <v-row>
    <v-col>
      <div class="v-card v-sheet Commodities-page">
        <v-container pb-4 grid-list-xl>
          <v-layout row wrap class="user-detailboxmain fixed-depositbox">
            <v-flex class="user-detailbox">
              <v-list-item v-for="savingDetail in savingAccountData" :key="savingDetail.id">
             <!--  {{savingDetail}} -->
                <v-list-item-content>
                  <v-list-item-title>
                    <h3 v-if="savingDetail.commodity_name">{{savingDetail.commodity_name}}</h3>
                    <h3 v-else></h3>
                  </v-list-item-title>
                  <v-list-item-subtitle  class="subtitle-details">
                    <div class="account-detailbox">
                      <div class="same-item">
                        <div class="bank-name">
                          <h5 v-if="savingDetail.name">{{savingDetail.name}}</h5>
                          <h5 v-else></h5>
                          <p v-if="savingDetail.purchase_no">{{savingDetail.purchase_no}}</p>
                          <p v-else></p>                        
                        </div>
                       <!--  <v-col class="memberbox-editbox">
                            <v-btn class="" outlined fab color="#F19700" @click="showHide(savingDetail['form_id']),showHideAgain(savingDetail['form_id'])">
                              <v-img max-height="20" max-width="20" :src="three_dots" :lazy-src="three_dots" class="mark"></v-img>
                            </v-btn>
                            <div v-if="hideShow && (hideShowId == savingDetail['form_id'])">
                              <v-btn @click="editAccounts(savingDetail['form_id'])">
                                <v-img
                                max-height="20"
                                max-width="20"
                                :src="edit_pic"
                                :lazy-src="edit_pic"
                                ></v-img> Edit
                                </v-btn>
                                <v-btn @click="deleteAccounts(savingDetail['form_id'])">
                                <v-img
                                max-height="23"
                                max-width="19"
                                :src=" delete_pic"
                                :lazy-src=" delete_pic"
                                > </v-img>Delete
                              </v-btn>
                            </div> 
                         </v-col>  -->
                         <v-col class="memberbox-editbox">
                            <v-menu bottom left offset-y>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  outlined fab
                                  color="#F19700"
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="showHide(savingDetail['form_id'])"
                                >
                                  <v-img max-height="20" max-width="20" :src="three_dots" :lazy-src="three_dots"></v-img>
                                </v-btn>
                              </template>
                              <v-list v-if="(hideShowId == savingDetail['form_id'])">
                                <v-list-item>
                                  <v-list-item-title>
                                    <v-btn @click="editAccounts(savingDetail['form_id'])">
                                      <v-img
                                      max-height="20"
                                      max-width="20"
                                      :src="edit_pic"
                                      :lazy-src="edit_pic"
                                      ></v-img> Edit
                                    </v-btn>
                                  </v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                  <v-list-item-title>
                                    <v-btn @click="deleteAccounts(savingDetail['form_id'])">
                                      <v-img
                                      max-height="23"
                                      max-width="19"
                                      :src=" delete_pic"
                                      :lazy-src=" delete_pic"
                                      > </v-img>Delete
                                    </v-btn>
                                  </v-list-item-title>
                                </v-list-item>
                                  <v-list-item>
                                  <v-list-item-title>
                                    <v-btn @click="updateUnit(savingDetail)">
                                      <v-img
                                      max-height="23"
                                      max-width="19"
                                      :src=" update_pic"
                                      :lazy-src=" update_pic"
                                      > </v-img>Update Unit
                                    </v-btn>
                                  </v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-col>
                       </div>
                         
                    </div>
                    <div class="maturity-Datebox">
                      <div class="bank-name">  
                        <span>Number of units
                        </span>
                        <p>{{savingDetail.unit}}</p>
                      </div>
                      <div class="amount-box">
                          <span>Spot Price as on {{savingDetail.commodity_price_updated_date}}</span>
                          <p v-if="savingDetail"><span> &#8377;</span> {{savingDetail.spot_price}}</p>
                          <p v-else></p>
                        </div>
                      
                    </div>
                    <div class="maturity-Datebox">
                      <div class="bank-name">  
                        <span>Exchange</span>
                        <p>{{savingDetail.exchange}}</p>
                      </div> 
                      <div class="amount-box">
                        <span>
                        Valuation on {{currentDate | moment("DD MMM, Y")}}   
                        </span>
                        <p><span> &#8377;</span> {{savingDetail.current_value}}</p>
                      </div>
                    </div>
                    <!-- <div class="maturity-Datebox">
                      <div class="bank-name">  
                        <span>Location
                        </span>
                        <p>{{savingDetail.location}}</p>
                      </div> 
                    </div> -->
                    <div class="maturity-Datebox">
                      <div class="bank-name">
                        <span>Nominees</span>
                        <p v-if="savingDetail.nominee.length != 0">
                          <span v-for="(items,index) in savingDetail.nominee">{{items}}<span v-if="savingDetail.nominee.length > index+1">, </span></span>
                        </p>
                        <p v-else>N/A</p>
                      </div>
                    </div>
                  </v-list-item-subtitle> 
                </v-list-item-content>  
              </v-list-item>
            </v-flex>
          </v-layout>  
        </v-container>  
        <div class="total-amount-box" v-if="savingAccountData.length != 0">
            <h4>Total Commodity Valuation</h4>
            <div class="total-amount">
              <span>As on {{currentDate | moment("DD MMM, Y")}}</span>
              <p><span> &#8377;</span> {{totalValue.toLocaleString()}}</p>
            </div>
        </div>
        <div v-else>
          <v-list-item>
            <div class="user-detailbox">
              <v-list-item-content>
                <div class="text-h5 mb-1">
                  No data found.
                </div>
              </v-list-item-content>
            </div>
          </v-list-item>
        </div>
      </div>
       
    </v-col>
  </v-row>
  <modal class="common-modal-box small-modal-box my-custom-modal" name="update-unit"> 
    <span class="close"> 
      <v-img width="20" height="20" @click="close" style="float: right;" :src="require('@/assets/images/cross.png')">
      </v-img>
    </span>
    <v-form ref="update" lazy-validation>
        <v-text-field
          v-model="update_unit"
          value=""
          :rules="[(v) => !!v || 'Field is required']"
          placeholder="Enter Number of Units"
          class="balance-field"
        >
        </v-text-field>
        <!-- <a  href="javascript:void(0)"
          v-on:click="getAccountHelpDetail()">GET HELP ?</a> -->
        <v-btn class="update-btn" @click="updatecommodityUnit()" >Update Unit</v-btn>
    </v-form>
  </modal>
  </div>
</template>
<script>
import { Auth } from "aws-amplify";
  import { POST_API, GET_API, GET_COMMODITY_FORM_DETAIL, DELETE_FORM } from "../../../store/actions.type";
  import { isEmpty } from 'lodash';
  import axios from "axios";
  export default {
    data () {
      return {
        three_dots:process.env.VUE_APP_ROOT_ICONS_URL + 'three_dots.png',
        currentDate: new Date().setDate(new Date().getDate()),
        amount:0,
        // savingAccountData:'',
        edit_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'edit.png',
        delete_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'delete.png',
        update_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'update.png',
        hideShow:false,
        hideShowId:'',
        update_unit:'',
        full_name:''
      }
    },
    created(){
      Fire.$on("loadData", () => {
        this.savingAccountList();
      });
    },
    mounted () {
      if(this.isDataEmpty) this.savingAccountList();  
      
    },
    // mounted() {
      
    //    Fire.$on("commidities", () => {
    //       this.savingAccountList();
    //     });
    //    Fire.$on("refreshBullionDashbaords", () => {
    //       this.savingAccountList();
    //     });
    //     this.savingAccountList();
    // },
    computed: {
      
      isDataEmpty: function () {
        return isEmpty(this.$store.getters.getCommodityFormDetail);
      },
      savingAccountData: function () {
        return !this.isDataEmpty ? this.$store.getters.getCommodityFormDetail.data.commodity_detail : [];
      }
      ,totalValue: function () {
        return !this.isDataEmpty ? this.$store.getters.getCommodityFormDetail.balance_array.total : 0;
      },
      
      
    },
    methods:{
      close(){
        this.$modal.hide("update-unit");
      },
     showHide(id){
        this.hideShowId = id;
        this.hideShow = this.hideShow ? false : true;
      },
      showHideAgain(id){
        if (this.hideShow == true) {
          //this.hideShow = false; 
        }

          //this.hideShow = true;

      },
      updateUnit(savingData){
        this.$modal.show("update-unit");
        this.form_id = savingData.form_id;

      },
       updatecommodityUnit() {
      if (this.$refs.update.validate()) {
        console.log(this.form_id,this.update_unit)
        let formdata = new FormData();
        formdata.append(
          "aws_cognito_id",
          atob(localStorage.getItem("cognito_idp"))
        );
        formdata.append("form_id", this.form_id);
        formdata.append("unit", this.update_unit);
        formdata.append("module_type", 'commodity');
        //  console.log(formdata);
        axios
          .post(process.env.VUE_APP_ROOT_API + "update-units", formdata)
          .then((res) => {
            this.$modal.hide("update-unit");
            swal.fire({
              title: "Unit Updated Successfully",
              icon: "success",
            });
           this.savingAccountList();
          })
          .catch(() => {});
      }
    },
      editAccounts(editId){
        this.$router.push({ path: "/edit-commodities/"+btoa(editId) }).catch(()=>{});
      },
      deleteAccounts(id){
          swal
        .fire({
          title: "Are you sure, you want to delete this data?",
          showCancelButton: true,
          confirmButtonColor: `#051d42`,
          confirmButtonText: `YES`,
          cancelButtonColor: `#f19700`,
        })
        .then(result => {
          if (result.isConfirmed) {
            let cognito_idp = atob(localStorage.getItem('cognito_idp'));
            let user_name = this.$store.getters.getUserDetails.user_name;
            this.$store.dispatch(DELETE_FORM, {
              data: {
                aws_cognito_id: cognito_idp,
                form_id:id,
              },
              api: "delete-form",
            })
            .then(() => {
              this.savingAccountList();
              // Fire.$emit('commiditiesDelete');
              Toast.fire({
                    icon: 'success',
                    title: 'Data deleted successfully.'
              })
            });

          } else if (result.isDenied) {
            Swal.fire("Changes are not saved", "", "info");
          }
        });
      },
      savingAccountList(){
        this.$loading(true);
        let cognito_idp = atob(localStorage.getItem('cognito_idp'));
        let user_name = this.$store.getters.getUserDetails.user_name;
        let selected_value = this.$store.getters.getUserDetails.selected_value;
        this.$store.dispatch(GET_COMMODITY_FORM_DETAIL, {
          data: {
            aws_cognito_id: cognito_idp,
            user_name:user_name,
            member_id:selected_value,
          },
          api: "get-commodity-form-detail",
        })
        .then(() => {
          Fire.$emit("commidities");
          // this.savingAccountData = this.$store.getters.getCommodityFormDetail.data.commodity_detail;
          // this.amount = this.$store.getters.getCommodityFormDetail.data.tot_scheme_balance;
            this.$loading(false);

        }).catch(() => {
           this.$loading(false);
        });
      },
    }
  }
</script>
